// ============================================================
// CART BADGE — icona carrello con contatore per la Navbar
// ============================================================

import React from 'react';
import { Nav } from 'react-bootstrap';
import { useCart } from '../../../../contexts/CartContext';
import './CartBadge.css';
import { Cart3 } from 'react-bootstrap-icons';
import { useTheme } from '../../../../contexts/ThemeContext';

interface CartBadgeProps {
  onClick?: () => void;
}

const CartBadge: React.FC<CartBadgeProps> = ({ onClick }) => {
  const { toggleCart, totalItems } = useCart();
  const { isDarkMode } = useTheme();

  const handleClick = () => {
    onClick?.();
    toggleCart();
  };

  return (
    <Nav.Link
      className="cart-badge-container me-3"
      onClick={handleClick}
      aria-label={`Carrello: ${totalItems} ${totalItems === 1 ? 'corso' : 'corsi'}`}
      title={`Carrello: ${totalItems} ${totalItems === 1 ? 'corso' : 'corsi'}`}
    >
      <Cart3
        size={22}
        className={`cart-badge-icon ${isDarkMode ? 'text-light' : 'text-dark'}`}
      />
      {totalItems > 0 && (
        <span className="cart-badge-count" aria-hidden="true">
          {totalItems > 9 ? '9+' : totalItems}
        </span>
      )}
    </Nav.Link>
  );
};

export default CartBadge;
